import { FileIcon, ImageIcon, VideoIcon } from "../../../../packages/icons";
import {
  PHOTO_EXTENSIONS,
  VIDEO_EXTENSIONS,
} from "../../../../packages/constants";

type Props = {
  filename: string;
};

export const FileIconComponent = ({ filename }: Props) => {
  const extension = filename.split(".").pop()?.toLowerCase() || "";

  if (PHOTO_EXTENSIONS.includes(extension)) {
    return <ImageIcon />;
  }

  if (VIDEO_EXTENSIONS.includes(extension)) {
    return <VideoIcon />;
  }

  return <FileIcon />;
};
